import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { graphql } from "gatsby"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import styled from "styled-components"

import Row from "../components/themableUI/row"
import Col from "../components/themableUI/col"

const StyledPictureLink = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  padding: 1rem;
`

const WorkPage = ({ data }) => (
  <Layout>
    <SEO title="Work" />
    <h2 style={{ display: "none" }}>Work</h2>

    <Row>
      {data.allMarkdownRemark.edges.map(post => {
        const featImage = getImage(post.node.frontmatter.featuredImage)
        const imgNode = featImage ? (
          <GatsbyImage
            style={{ margin: 0, marginLeft: "auto", display: "block" }}
            image={featImage}
            alt=""
          />
        ) : (
          <></>
        )

        return (
          <Col
            size={12}
            offset={0}
            sizes={{ md: 8, lg: 4 }}
            offsets={{ md: 2, lg: 0 }}
            key={post.node.id}
            style={{ padding: "0rem" }}
          >
            <StyledPictureLink>
              <Link to={post.node.frontmatter.path}>
              

                <h3
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate3d(-50%, -50%, 0)",
                    margin: "0 auto",
                    color: "white",
                    textTransform: "uppercase",
                    zIndex: 1,
                    fontSize: "2rem",
                  }}
                >
                  {post.node.frontmatter.title}
                </h3>

                {imgNode}
              </Link>
            </StyledPictureLink>
          </Col>
        )
      })}
    </Row>
  </Layout>
)

export const pageQuery = graphql`
  query workIndexQuery {
    allMarkdownRemark(filter: { frontmatter: { type: { eq: "work" } } }) {
      edges {
        node {
          id
          frontmatter {
            title
            path
            date
            type
            featuredImage {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  width: 400
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
  }
`

export default WorkPage
